// 默认 COS region
const DEFAULT_COS_REGION = 'guangzhou';

// 支持的 COS region 列表（用于验证）
const SUPPORTED_COS_REGIONS: string[] = ['guangzhou', 'singapore'];

/**
 * 标准化 COS region（处理大小写、别名等）
 * @param region - COS的region
 * @return COS的region
 */
export const getValidCOSRegion = (region?: string | null): string => {
  if (!region) {
    return DEFAULT_COS_REGION;
  }

  const regionTmp = region.toLowerCase().trim();

  return SUPPORTED_COS_REGIONS.includes(regionTmp) ? regionTmp : DEFAULT_COS_REGION;
};
